import Vue from 'vue';
import { gsap } from 'gsap';
import Axios from 'axios';
import Autocomplete from 'vue2-autocomplete-js';

Vue.component('search-overlay-component', {
    components: {
        Autocomplete,
    },

    data() {
        return {
            // showSearch: false,
            searchData: [],
            searchValue: null,
            noResultsFound: false,
        };
    },

    mounted() {
        EventBus.$on('search-toggle', (showSearch) => {
            if (showSearch) {
                this.searchCloseAnim();
                return;
            }

            this.searchOpenAnim();
        });

        this.searchBG = document.querySelector('.search-overlay--bg');
        this.searchBorder = document.querySelector('.autocomplete-input-border');
        this.searchInput = document.querySelector('.autocomplete-wrapper');
        this.searchBlock = document.querySelector('.header__block--search');
        this.searchClose = {
            holder: document.querySelector('.search-close-holder'),
            start: document.querySelector('.search-close-start'),
            end: document.querySelector('.search-close-end'),
        };
        this.hamburger = {
            start: document.querySelector('.hamburger-start'),
            inner: document.querySelector('.hamburger-inner'),
            end: document.querySelector('.hamburger-end'),
        };

        this.headerBlockActiveHolder = document.querySelector('.header__block--active-holder');
        this.headerBlockActive = document.querySelector('.header__block--active');
    },

    methods: {
        getData(data) {
            this.searchData = data.data;

            this.noResultsFound = false;

            gsap.delayedCall(0.2, () => {
                if (this.searchValue.length !== 0 && this.searchData.length === 0) {
                    this.noResultsFound = true;
                }
            });
        },
        itemSelected(data) {
        },
        processJsonData(json) {
            //     return json.data;
        },
        onInput(data) {
            this.searchValue = data;

            const autocompleteInput = this.$el.querySelector('.autocomplete-input');
            autocompleteInput.addEventListener('keyup', (event) => {
                if (event.key === 'Enter') {
                    window.location.href = `/search?q=${data}`;
                }
            });
        },

        searchOpenAnim() {
            if (this.isAnimating) {
                return;
            }

            this.isAnimating = true;

            const windowWidth = window.innerWidth;
            const tl = gsap.timeline();

            tl
                .fromTo(this.searchBG, {
                    x: windowWidth,
                    rotate: 13,
                }, {
                    onStart: () => {
                        EventBus.$emit('search-toggle-state', true);
                    },
                    duration: 1.5,
                    x: 0,
                    rotate: 0,
                    ease: 'power4.out',
                })
                .to(this.searchBorder, {
                    duration: 1,
                    x: 0,
                    ease: 'power3.out',
                }, '<0.25')
                .to(this.searchBlock, {
                    duration: 0.8,
                    x: 160,
                    zIndex: 1,
                    ease: 'power3.in',
                    onComplete: () => {
                        gsap.set(this.searchBlock, {
                            zIndex: 7,
                        });
                    },
                }, '<')
                .to([this.hamburger.start, this.hamburger.inner, this.hamburger.end], {
                    duration: 0.8,
                    x: 35,
                    stagger: 0.1,
                    ease: 'power3.out',
                }, '<')
                .to(this.searchInput, {
                    duration: 1.5,
                    alpha: 1,
                    ease: 'power3.out',
                }, '-=0.2')
                .set(this.headerBlockActiveHolder, {
                    x: 80,
                }, '<')
                .to(this.headerBlockActive, {
                    duration: 0.4,
                    x: 0,
                    ease: 'power2.out',
                }, '<')
                .set(this.searchClose.holder, {
                    x: -80,
                }, '<')
                .to(this.searchClose.start, {
                    duration: 0.4,
                    x: 6,
                    y: 20,
                    ease: 'power3.out',
                }, '<')
                .to(this.searchClose.end, {
                    duration: 0.4,
                    x: 6,
                    y: 18,
                    ease: 'power3.out',
                    onComplete: () => {
                        this.isAnimating = false;
                    },
                }, '<0.05');
        },

        searchCloseAnim() {
            if (this.isAnimating) {
                return;
            }

            this.isAnimating = true;

            const windowWidth = window.innerWidth;
            const tlOut = gsap.timeline();

            tlOut
                .fromTo(this.searchBG, {
                    x: 0,
                    rotate: 0,
                }, {
                    duration: 1.5,
                    x: windowWidth + 175,
                    rotate: 13,
                    ease: 'power4.in',
                })
                .to([this.searchInput, this.searchBorder], {
                    duration: 1,
                    alpha: 0,
                    ease: 'power3. out',
                }, '<')
                .to(this.searchClose.start, {
                    duration: 0.4,
                    x: -25,
                    y: 50,
                    ease: 'power3.out',
                }, '<')
                .to(this.searchClose.end, {
                    duration: 0.4,
                    x: -25,
                    y: -14,
                    ease: 'power3.out',
                }, '<0.05')
                .to(this.headerBlockActive, {
                    duration: 0.4,
                    x: -80,
                    ease: 'power2.out',
                }, '<0.2')
                .to([this.hamburger.start, this.hamburger.inner, this.hamburger.end], {
                    duration: 0.8,
                    x: 0,
                    stagger: 0.1,
                    ease: 'power3.out',
                }, '<0.3')
                .set(this.searchBlock, {
                    zIndex: 1,
                })
                .to(this.searchBlock, {
                    duration: 0.8,
                    x: 0,
                    ease: 'power3.out',
                }, '<0.3')
                .set(this.headerBlockActiveHolder, {
                    x: 160,
                    onComplete: () => {
                        EventBus.$emit('search-toggle-state', false);
                        this.isAnimating = false;
                    },
                });
        },

    },

    beforeDestroy() {

    },
});
